import getConfig from "next/config";

interface Config {
  apiUrl: string;
  appUrl: string;
  sentryDsn: string | undefined;
  sentryEnvironment: string | undefined;
  sentryTracesSampleRate: number | undefined;
  amplitudeApiKey: string;
  googleAnalyticsTrackingId: string;
  enableTestLogin: boolean;
  maintenanceStart: string | undefined;
  maintenanceDuration: number | undefined;
  fingerprintJsToken: string;
  candidatePortalUrl: string;
  linkedinOrganizationId: string;
  recaptchaSiteKey: string;
  recaptchaV2SiteKey: string;
}

let config: Config;

if (process.env.NODE_ENV === "test") {
  const oneHourLater = new Date();
  oneHourLater.setHours(oneHourLater.getHours() + 1);

  config = {
    apiUrl: "https://api.test",
    appUrl: "https://app.test",
    sentryDsn: undefined,
    sentryEnvironment: undefined,
    sentryTracesSampleRate: undefined,
    amplitudeApiKey: "",
    googleAnalyticsTrackingId: "",
    enableTestLogin: true,
    maintenanceStart: oneHourLater.toISOString(),
    maintenanceDuration: 3600,
    fingerprintJsToken: "",
    candidatePortalUrl: "https://candidate.hire.toggl.space",
    linkedinOrganizationId: "",
    recaptchaSiteKey: "",
    recaptchaV2SiteKey: "",
  };
} else {
  const { publicRuntimeConfig } = getConfig();

  config = {
    apiUrl: publicRuntimeConfig?.apiUrl ?? "",
    appUrl: publicRuntimeConfig?.appUrl ?? "",
    sentryDsn: publicRuntimeConfig?.sentryDsn ?? undefined,
    sentryEnvironment: publicRuntimeConfig?.sentryEnvironment ?? undefined,
    sentryTracesSampleRate:
      publicRuntimeConfig?.sentryTracesSampleRate ?? undefined,
    amplitudeApiKey: publicRuntimeConfig?.amplitudeApiKey ?? "",
    googleAnalyticsTrackingId:
      publicRuntimeConfig?.googleAnalyticsTrackingId ?? "",
    enableTestLogin: publicRuntimeConfig?.enableTestLogin ?? false,
    maintenanceStart: publicRuntimeConfig?.maintenanceStart,
    maintenanceDuration: publicRuntimeConfig?.maintenanceDuration,
    fingerprintJsToken: publicRuntimeConfig?.fingerprintJsToken,
    candidatePortalUrl: publicRuntimeConfig?.candidatePortalUrl,
    linkedinOrganizationId: publicRuntimeConfig?.linkedinOrganizationId,
    recaptchaSiteKey: publicRuntimeConfig?.recaptchaSiteKey,
    recaptchaV2SiteKey: publicRuntimeConfig?.recaptchaV2SiteKey,
  };
}

export default config;
